import React, { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import TopBar from './components/TopBar';
import NavBar from './components/NavBar';
import List from './components/List/List';
import ListEditor from './components/List/ListEditor';
import Products from './components/Products/Products';
import './App.css';
import ConfirmationModal from './components/ConfirmationModal';
import DefaultProducts from './products.json';

// Immediately get "myList" from the local storage, or create it if it doesn't exist
let initialList;
(function() {
	let initialLocalstorage = window.localStorage.getItem('myList');
	if (JSON.parse(initialLocalstorage) != null) {
		initialList = JSON.parse(initialLocalstorage);
	} else {
		initialList = {
			roomtemp: [],
			fridge: [],
			freezer: []
		};
		let json = JSON.stringify(initialList);
		window.localStorage.setItem('myList', json);
	}
})();

// Immediately get the products list from the local storage, or create it if it doesn't exist
let initialProducts;
(function() {
	let initialLocalstorage = window.localStorage.getItem('products');
	if (JSON.parse(initialLocalstorage) != null) {
		initialProducts = JSON.parse(initialLocalstorage);
	} else {
		let index = 0;
		initialProducts = {
			roomtemp: DefaultProducts.roomtemp.map((element) => (element = { ...element, id: index++ })),
			fridge: DefaultProducts.fridge.map((element) => (element = { ...element, id: index++ })),
			freezer: DefaultProducts.freezer.map((element) => (element = { ...element, id: index++ }))
		};
		let json = JSON.stringify(initialProducts);
		window.localStorage.setItem('products', json);
	}
})();

// TEST list
// let myList = {
// 	roomtemp: [
// 		{
// 			name: 'Pâtes',
// 			quantity: 2,
// 			type: 'roomtemp',
// 			checked: true,
// 			id: 0
// 		},
// 		{
// 			name: 'Farine',
// 			quantity: 1,
// 			type: 'roomtemp',
// 			checked: false,
// 			id: 1
// 		}
// 	],
// 	fridge: [
// 		{
// 			name: 'Lait',
// 			quantity: 1,
// 			type: 'fridge',
// 			checked: false,
// 			id: 2
// 		},
// 		{
// 			name: 'Concombres',
// 			quantity: 3,
// 			type: 'fridge',
// 			checked: false,
// 			id: 3
// 		}
// 	],
// 	freezer: [
// 		{
// 			name: "Ben & Jerry's",
// 			quantity: 1,
// 			type: 'freezer',
// 			checked: false,
// 			id: 4
// 		}
// 	]
// };

// TEST product list
// let initialProducts = {
// 	roomtemp: [
// 		{
// 			name: 'Pâtes',
// 			type: 'roomtemp',
// 			checked: true,
// 			id: 0
// 		},
// 		{
// 			name: 'Farine',
// 			type: 'roomtemp',
// 			checked: false,
// 			id: 1
// 		}
// 	],
// 	fridge: [],
// 	freezer: []
// };

let emptyList = {
	roomtemp: [],
	fridge: [],
	freezer: []
};

function App() {
	// myList
	// initialList
	const [ myList, setList ] = useState(initialList);
	const [ products, setProducts ] = useState(initialProducts);
	const [ headerTitle, setHeaderTitle ] = useState('Ma liste');
	const [ modal, setModal ] = useState(false);

	const tellMe = (target = false) => {
		if (target) {
			if (target === 'p') {
				console.log('Produits');
				console.table(products.roomtemp);
				console.table(products.fridge);
				console.table(products.freezer);
			} else {
				console.log('Liste');
				console.table(myList.roomtemp);
				console.table(myList.fridge);
				console.table(myList.freezer);
			}
		} else {
			console.log('Liste');
			console.table(myList.roomtemp);
			console.table(myList.fridge);
			console.table(myList.freezer);

			console.log('Produits');
			console.table(products.roomtemp);
			console.table(products.fridge);
			console.table(products.freezer);
		}
	};

	const copyToClipboard = () => {
		let str = getListAsText();
		let el = document.createElement('textarea');
		el.value = str;
		el.setAttribute('readonly', '');
		el.style.position = 'absolute';
		el.style.left = '-9999px';
		document.body.appendChild(el);
		el.select();
		document.execCommand('copy');
		document.body.removeChild(el);
	};

	const getListAsText = () => {
		let text = '';
		for (let i = 0; i < myList.roomtemp.length; i++) {
			const element = myList.roomtemp[i];
			if (i === myList.roomtemp.length - 1) {
				text += `- ${element.name} x ${element.quantity} \n\n`;
			} else {
				text += `- ${element.name} x ${element.quantity} \n`;
			}
		}

		for (let i = 0; i < myList.fridge.length; i++) {
			const element = myList.fridge[i];
			if (i === myList.fridge.length - 1) {
				text += `- ${element.name} x ${element.quantity} \n\n`;
			} else {
				text += `- ${element.name} x ${element.quantity} \n`;
			}
		}

		for (let i = 0; i < myList.freezer.length; i++) {
			const element = myList.freezer[i];
			text += `- ${element.name} x ${element.quantity} \n`;
		}

		return text;
	};

	const sortList = (list, sortChecks = true) => {
		if (!list) {
			return false;
		}

		list = list.sort((a, b) => {
			return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
		});

		if (sortChecks) {
			return list.sort((a, b) => {
				if (a.checked !== b.checked) {
					if (a.checked === true) {
						return 1;
					} else {
						return -1;
					}
				} else {
					return 0;
				}
			});
		} else {
			return list;
		}
	};

	const isListEmpty = () => {
		if (!myList.roomtemp.length && !myList.fridge.length && !myList.freezer.length) {
			return true;
		} else {
			return false;
		}
	};

	const saveListToLocalstorage = (newList) => {
		if (newList.roomtemp.length || newList.fridge.length || newList.freezer.length) {
			let json = JSON.stringify(newList);
			window.localStorage.setItem('myList', json);
		} else {
			let json = JSON.stringify(emptyList);
			window.localStorage.setItem('myList', json);
		}
	};

	const saveProductsToLocalstorage = (newList) => {
		console.log(newList);
		if (newList.roomtemp.length || newList.fridge.length || newList.freezer.length) {
			let json = JSON.stringify(newList);
			window.localStorage.setItem('products', json);
		} else {
			let json = JSON.stringify(emptyList);
			window.localStorage.setItem('products', json);
		}
	};

	const makeListComplete = () => {
		// Making sure the list isn't missing any of the sublists
		let copyList = JSON.parse(JSON.stringify(myList));
		if (!copyList.roomtemp) {
			copyList.roomtemp = [];
		}

		if (!copyList.fridge) {
			copyList.roomtemp = [];
		}

		if (!copyList.feezer) {
			copyList.roomtemp = [];
		}

		return copyList;
	};

	const updateList = (newList) => {
		setList(newList);
		saveListToLocalstorage(newList);
	};

	const updateSublist = (newList, type) => {
		let updatedList = JSON.parse(JSON.stringify(myList));
		updatedList[type] = newList;
		setList(updatedList);
		saveListToLocalstorage(updatedList);
	};

	const searchSublistById = (id, type, targetList) => {
		for (let i = 0; i < targetList[type].length; i++) {
			const element = targetList[type][i];
			if (element.id === id) {
				return element;
			}
		}

		return false;
	};
	const searchSublistByName = (name, type, targetList) => {
		for (let i = 0; i < targetList[type].length; i++) {
			const element = targetList[type][i];
			if (element.name === name) {
				return element;
			}
		}

		return false;
	};

	/////////////////////////////
	//     Item methods     //
	/////////////////////////////
	const isItemIdUnique = (itemId) => {
		if (getItem(itemId)) {
			return false;
		}

		return true;
	};

	const generateItemId = () => {
		let isUnique = false;

		for (let index = 0; isUnique === false; index++) {
			let generatedId = Math.floor(Math.random() * 1000);
			if (isItemIdUnique(generatedId)) {
				isUnique = true;
				return generatedId;
			}
		}
	};

	const addItem = (item) => {
		let targetList = myList[item.type] ? JSON.parse(JSON.stringify(myList[item.type])) : [];
		item.id = generateItemId(myList);
		targetList.push(item);
		updateSublist(targetList, item.type);
	};

	const getItem = (itemId) => {
		itemId = parseInt(itemId);
		if (myList.roomtemp) {
			if (searchSublistById(itemId, 'roomtemp', myList)) {
				let item = searchSublistById(itemId, 'roomtemp', myList);
				return item;
			}
		}

		if (myList.fridge) {
			if (searchSublistById(itemId, 'fridge', myList)) {
				let item = searchSublistById(itemId, 'fridge', myList);
				return item;
			}
		}

		if (myList.freezer) {
			if (searchSublistById(itemId, 'freezer', myList)) {
				let item = searchSublistById(itemId, 'freezer', myList);
				return item;
			}
		}

		return false;
	};

	const deleteItem = (itemId, itemType) => {
		// If the target sublist doesn't exist, create it as an empty array
		if (!myList[itemType]) {
			let listToChange = JSON.parse(JSON.stringify(myList));
			listToChange[itemType] = [];
			updateSublist(listToChange, itemType);
			return;
		}

		let listToChange = myList[itemType];
		for (let i = 0; i < listToChange.length; i++) {
			const element = listToChange[i];
			if (element.id === parseInt(itemId)) {
				listToChange.splice(i, 1);
			}
		}

		updateSublist(listToChange, itemType);
	};

	const editItem = (item) => {
		let newType = item.type;
		let oldType = item.oldType;
		let itemId = item.id;

		if (newType !== oldType && oldType) {
			let list = JSON.parse(JSON.stringify(myList));

			// We delete and add manually, because if we used the deleteProduct and addProduct functions,
			// the "delete" wouldn't finish updating the state before the "add" starts modifying the list too, as the state hook is asyncronous
			for (let i = 0; i < list[oldType].length; i++) {
				if (list[oldType][i].id === parseInt(itemId)) {
					list[oldType].splice(i, 1);
				}
			}

			// If the new list doesn't exist yet, create it
			if (!list[newType]) {
				list[newType] = [];
			}

			item.id = generateProductId();
			delete item.initialName;
			delete item.oldType;
			list[newType].push(item);
			updateList(list);
		} else {
			let targetList = JSON.parse(JSON.stringify(myList[item.type]));

			for (let i = 0; i < targetList.length; i++) {
				const element = targetList[i];
				if (element.id === parseInt(itemId)) {
					targetList[i] = item;
				}
			}
			updateSublist(targetList, item.type);
		}
	};

	const handleCheckboxChange = (target) => {
		let itemId = target.value;
		let itemType = target.getAttribute('data-type');
		let itemCheck = target.checked;
		let listToChange = JSON.parse(JSON.stringify(myList[itemType]));

		for (let i = 0; i < listToChange.length; i++) {
			const element = listToChange[i];
			if (element.id === parseInt(itemId)) {
				element.checked = itemCheck;
			}
		}

		updateSublist(listToChange, itemType);
	};

	const filterList = (searchValue, list) => {
		let returnValues = {
			searchResults: {
				roomtemp: [],
				fridge: [],
				freezer: []
			},
			searchMatch: false
		};

		if (searchValue && searchValue.length >= 3) {
			for (let i = 0; i < list.roomtemp.length; i++) {
				const element = list.roomtemp[i];

				if (element.name.toLowerCase().includes(searchValue.toLowerCase())) {
					returnValues.searchResults.roomtemp.push(element);
					returnValues.searchMatch = true;
				}
			}

			for (let i = 0; i < list.fridge.length; i++) {
				const element = list.fridge[i];
				if (element.name.toLowerCase().includes(searchValue.toLowerCase())) {
					returnValues.searchResults.fridge.push(element);
					returnValues.searchMatch = true;
				}
			}

			for (let i = 0; i < list.freezer.length; i++) {
				const element = list.freezer[i];
				if (element.name.toLowerCase().includes(searchValue.toLowerCase())) {
					returnValues.searchResults.freezer.push(element);
					returnValues.searchMatch = true;
				}
			}
		}

		return returnValues;
	};

	/////////////////////////////
	//     Product methods     //
	/////////////////////////////
	const isProductListEmpty = () => {
		if (!products.roomtemp.length && !products.fridge.length && !products.freezer.length) {
			return true;
		} else {
			return false;
		}
	};
	const isProductIdUnique = (productId) => {
		if (getProduct(productId)) {
			return false;
		}

		return true;
	};

	const generateProductId = () => {
		let isUnique = false;

		for (let index = 0; isUnique === false; index++) {
			let generatedId = Math.floor(Math.random() * 1000);
			if (isProductIdUnique(generatedId)) {
				isUnique = true;
				return generatedId;
			}
		}
	};

	const updateProducts = (newList) => {
		setProducts(newList);
		saveProductsToLocalstorage(newList);
	};

	const updateProductsSublist = (newList, type) => {
		let updatedList = JSON.parse(JSON.stringify(products));
		updatedList[type] = newList;
		setProducts(updatedList);
		saveProductsToLocalstorage(updatedList);
	};

	const addProduct = (product) => {
		let targetList = products[product.type] ? JSON.parse(JSON.stringify(products[product.type])) : [];
		product.id = generateProductId();
		targetList.push(product);
		updateProductsSublist(targetList, product.type);
	};

	const getProduct = (productId) => {
		productId = parseInt(productId);
		if (products.roomtemp) {
			if (searchSublistById(productId, 'roomtemp', products)) {
				let product = searchSublistById(productId, 'roomtemp', products);
				return product;
			}
		}

		if (products.fridge) {
			if (searchSublistById(productId, 'fridge', products)) {
				let product = searchSublistById(productId, 'fridge', products);
				return product;
			}
		}

		if (products.freezer) {
			if (searchSublistById(productId, 'freezer', products)) {
				let product = searchSublistById(productId, 'freezer', products);
				return product;
			}
		}

		return false;
	};

	const deleteProduct = (productId, type) => {
		// If the target sublist doesn't exist, create it as an empty array
		if (!products[type]) {
			let listToChange = JSON.parse(JSON.stringify(products));
			listToChange[type] = [];
			updateProductsSublist(listToChange, type);
			return;
		}

		let listToChange = JSON.parse(JSON.stringify(products[type]));

		for (let i = 0; i < listToChange.length; i++) {
			const element = listToChange[i];
			if (element.id === parseInt(productId)) {
				listToChange.splice(i, 1);
			}
		}

		updateProductsSublist(listToChange, type);
	};

	const editProduct = (product) => {
		let newType = product.type;
		let oldType = product.oldType;
		let productId = product.id;
		if (newType !== oldType && oldType) {
			let productsList = JSON.parse(JSON.stringify(products));
			// If the product is in a new category (roomtemp, fridge, etc.), delete it and add it in the new category

			// We delete and add manually, because if we used the deleteProduct and addProduct functions,
			// the "delete" wouldn't finish updating the state before the "add" starts modifying the list too, as the state hook is asyncronous
			for (let i = 0; i < productsList[oldType].length; i++) {
				if (productsList[oldType][i].id === parseInt(productId)) {
					productsList[oldType].splice(i, 1);
				}
			}

			// If the new list doesn't exist yet, create it
			if (!productsList[newType]) {
				productsList[newType] = [];
			}

			delete product.initialName;
			delete product.oldType;
			product.id = generateProductId();
			productsList[newType].push(product);
			updateProducts(productsList);
		} else {
			// If it's in the same category, simply change it
			let targetList = JSON.parse(JSON.stringify(products[newType]));

			for (let i = 0; i < targetList.length; i++) {
				const element = targetList[i];
				if (element.id === parseInt(productId)) {
					targetList[i] = product;
				}
			}
			updateProductsSublist(targetList, newType);
		}
	};

	const handleProductCheckboxChange = (target) => {
		let itemId = target.value;
		let itemType = target.getAttribute('data-type');
		let itemCheck = target.checked;
		let listToChange = JSON.parse(JSON.stringify(products[itemType]));

		for (let i = 0; i < listToChange.length; i++) {
			const element = listToChange[i];
			if (element.id === parseInt(itemId)) {
				element.checked = itemCheck;
			}
		}

		updateProductsSublist(listToChange, itemType);
	};

	const checkDuplicates = (item, target) => {
		let listToCheck;
		if (target === 'list') {
			listToCheck = myList;
		} else if (target === 'products') {
			listToCheck = products;
		}

		for (let i = 0; i < listToCheck[item.type].length; i++) {
			const element = listToCheck[item.type][i];
			if (element.name.toLowerCase() === item.name.toLowerCase()) {
				return true;
			}
		}

		return false;
	};

	const checkAllProducts = (bool) => {
		let copyList = JSON.parse(JSON.stringify(products));
		for (const sublist in copyList) {
			if (copyList[sublist]) {
				copyList[sublist].forEach((element) => {
					element.checked = bool;
				});
			}
		}

		updateProducts(copyList);
	};

	const addProductsToList = (items) => {
		let listToUpdate = JSON.parse(JSON.stringify(myList));
		items.forEach((element) => {
			if (!searchSublistByName(element.name, element.type, myList)) {
				let itemId = generateItemId();
				listToUpdate[element.type].push({ ...element, quantity: 1, id: itemId, checked: false });
			}
		});

		updateList(listToUpdate);
		checkAllProducts(false);
	};

	const resetList = () => {
		setList(emptyList);
		saveListToLocalstorage([]);
	};

	const resetProducts = () => {
		let index = 0;
		let defaultProducts = {
			roomtemp: DefaultProducts.roomtemp.map((element) => (element = { ...element, id: index++ })),
			fridge: DefaultProducts.fridge.map((element) => (element = { ...element, id: index++ })),
			freezer: DefaultProducts.freezer.map((element) => (element = { ...element, id: index++ }))
		};
		setProducts(defaultProducts);
		saveProductsToLocalstorage(defaultProducts);
	};

	const emptyProducts = () => {
		setProducts(emptyList);
		saveProductsToLocalstorage([]);
	};

	const itemMethods = {
		add: addItem,
		edit: editItem,
		delete: deleteItem,
		get: getItem,
		checkDuplicates: checkDuplicates,
		search: filterList
	};

	const productMethods = {
		add: addProduct,
		edit: editProduct,
		delete: deleteProduct,
		get: getProduct,
		checkAll: checkAllProducts,
		checkDuplicates: checkDuplicates,
		search: filterList
	};

	return (
		<Router basename="/projets/grocery-app">
			<div onClick={getListAsText}>
				{modal ? (
					<ConfirmationModal
						type={modal}
						setModal={setModal}
						resetList={resetList}
						emptyProducts={emptyProducts}
						resetProducts={resetProducts}
					/>
				) : (
					''
				)}
				<TopBar
					setModal={setModal}
					isListEmpty={isListEmpty}
					isProductListEmpty={isProductListEmpty}
					copyToClipboard={copyToClipboard}
				>
					{headerTitle}
				</TopBar>

				<Switch>
					<Route path="/" exact>
						<List
							list={myList}
							sortList={sortList}
							handleCheckboxChange={handleCheckboxChange}
							setHeaderTitle={setHeaderTitle}
							isListEmpty={isListEmpty}
						/>
					</Route>

					<Route path="/lists">
						<ListEditor
							list={myList}
							sortList={sortList}
							handleCheckboxChange={handleCheckboxChange}
							itemMethods={itemMethods}
							setHeaderTitle={setHeaderTitle}
							isListEmpty={isListEmpty}
						/>
					</Route>

					<Route path="/products">
						<Products
							list={products}
							sortList={sortList}
							setHeaderTitle={setHeaderTitle}
							handleCheckboxChange={handleProductCheckboxChange}
							productMethods={productMethods}
							isListEmpty={isProductListEmpty}
							addProductsToList={addProductsToList}
						/>
					</Route>
				</Switch>
				<NavBar />
			</div>
		</Router>
	);
}

export default App;
